import { useState } from "react";

import ImageOnGridArchive from "../components/ImageOnGridArchive";
import ModalArchive from "../ui/ModalArchive";

import classes from "./css/Archive.module.css";

import SHOWS_ARCHIVE from "../data/SHOWS_ARCHIVE";

const ArchivePage = () => {
  const [isClicked, setIsClicked] = useState(false);
  const [modalShowData, setModalShowData] = useState();

  const onClickHandler = (show) => {
    setIsClicked(true);
    document.body.style.overflow = "hidden";

    setModalShowData(show);
  };

  const onCloseHandler = () => {
    setIsClicked(false);
    document.body.style.overflow = "unset";
  };

  return (
    <>
      {isClicked && (
        <ModalArchive onClose={onCloseHandler} show={modalShowData} />
      )}
      <div className={classes.main_archive}>
        <div className={classes.archive_header_main}>
          <div>
            <span>Arch</span>
            <span>ivio</span>
          </div>

          <h2>Galleria spettacoli dal 1989 al 2014</h2>
        </div>

        <div className={classes.grid_archive}>
          {SHOWS_ARCHIVE.map((show) => (
            <ImageOnGridArchive
              onClick={() => onClickHandler(show)}
              id={show.id}
              title={show.title}
              author={show.author}
              year={show.year}
              image={show.image}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default ArchivePage;
